import Vue from "vue";
import ResourceService from "./resource.service";
class ZoneService extends ResourceService {
  static get resource() {
    return 'zone'
  }

  static getAvailableZones(payload) {
    const url = `${this.resource}/get-available-zones`;
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, { params: payload })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default ZoneService;

